<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		index
		paging
		:pageUnit="groups.pageUnit"
		:pageArray="screen.pageArray"
		:currentPage="groups.currentPage"
		:totalSize="groups.totalSize"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/GuideBoard/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		columns() {
			return [
				{
					label: this.getMessage_('SWCC000330'), //버전
					prop: 'ver',
					minWidth: '50px'
				},
				{
					label: this.getMessage_('SWCC000844'), //구분
					prop: 'category',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000845'), //상세구분
					prop: 'dtlCategory',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000519'), //제목
					prop: 'title',
					minWidth: '300px',
					clickEvent: this.clickEvent,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000848'), //작성자
					prop: 'regId',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000849'), //작성일
					prop: 'regDt',
					minWidth: '180px'
				}
			];
		},
		rows() {
			return this.groups.data;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.$sf_toggleLoading(true);
			this.getGuideBoardList_({ ...this.searchParams, currentPage: currentPageVal, pageUnit: pageUnitVal })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		async clickEvent(row) {
			this.$sf_toggleLoading(true);

			const fileList = []; // 전체 파일 리스트
			const imgList = []; // 이미지 파일 리스트
			let fileInfoList = [];

			if (row.fileInfo) {
				const fileArray = row.fileInfo.split('|||');
				fileArray.forEach(element => {
					//console.log('element', element);
					const fileInfo = element.split('*');
					const fileName = fileInfo[0];
					const fileExt = fileInfo[1];
					const fileSize = fileInfo[2];
					const boardNo = fileInfo[3];
					const seq = fileInfo[4];
					fileInfoList.push({ fileName, fileExt, fileSize, boardNo, seq });

					this.imgDownload_({ no: boardNo, seq: seq }).then(file => {
						fileList.push(file);
						if ('|JPG|PNG|GIF|'.indexOf(fileExt.toUpperCase()) > -1) {
							imgList.push(file);
						}
					});

					//console.log('fileExt', fileExt.toUpperCase());
				});
			}

			this.defaultAssign_({ key: 'GuideBoardDetailValue', value: { ...this.GuideBoardDetailValue, fileList, imgList } });
			this.setDetailValue_({ key: 'boardNo', value: row.boardNo });
			this.setDetailValue_({ key: 'ver', value: row.ver });
			this.setDetailValue_({ key: 'category', value: row.category });
			this.setDetailValue_({ key: 'dtlCategory', value: row.dtlCategory });
			this.setDetailValue_({ key: 'title', value: row.title });
			this.setDetailValue_({ key: 'regId', value: row.regId });
			this.setDetailValue_({ key: 'conts', value: row.conts });
			this.setDetailValue_({ key: 'fileInfo', value: fileInfoList });
			this.defaultAssign_({ key: 'GuideBoardDetail', value: true });
			this.$sf_toggleLoading(false);
		}
	}
};
</script>
<style></style>
